import { Component, OnInit, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { AcademyService } from "../academies/service/academies.service";
import { maxYearFunction } from "src/app/_helpers/utility";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  templateUrl: "./academyTournamentReport.component.html",
  styleUrls: ["./academyTournamentReport.component.scss"],
  styles: [
    `
      :host ::ng-deep .p-datatable-gridlines p-progressBar {
        width: 100%;
      }

      @media screen and (max-width: 960px) {
        :host
          ::ng-deep
          .p-datatable.p-datatable-customers.rowexpand-table
          .p-datatable-tbody
          > tr
          > td:nth-child(6) {
          display: flex;
        }
      }
    `,
  ],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})
export class AcademyTournamentReport implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>(); 
  startDate: Date;
  endDate: Date;
  searchBy;
  searchby;
  wdcalvalue;
  hide: boolean = false;
  downloadFlg;
  lazyLoadEvent: LazyLoadEvent;
  loading: boolean;
  public academiesList: any[];
  public errorMessage;
  public totalRecords;
  public paginationOption;
  yearRange;
  minYear = environment.minYear;
  statuses;
  downloadAcademiesList: any[];
  constructor(
    private academyService: AcademyService
  ) { }
  ngOnInit() {
    this.searchBy = [
      { label: "Created On", value: "created_at" },
      { label: "Last Modified On", value: "updated_at" },
    ];
    this.paginationOption = environment.pagination;
    this.yearRange = this.minYear + ":" + maxYearFunction();
    this.statuses = [
      { label: "Active", value: true },
      { label: "In-Active", value: false },
    ];
    this.downloadFlg = false;
    this.loadAcademiesTournament(this.lazyLoadEvent);
  }

  loadAcademiesTournament(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let query = "?filterByDisable=false";
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    // if (event.first != undefined && event.first == 0) {
    //   pagenumber = event.first + 1;
    // } else if (event.first != undefined && event.first > 0) {
    //   pagenumber = (event.first / event.rows) + 1;
    // } else {
    //   pagenumber = 1;
    // }
    // if (event.rows != undefined) {
    //   rows = event.rows;
    // } else {
    //   rows = 10;
    // }
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    // if (event.filters != undefined && event.filters["name"] != undefined) {
    //   params += "&filterByName=" + event.filters["name"].value;
    // }

    // if (event.filters != undefined && event.filters["created_at"] != undefined) {
    //   const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
    //   params += "&filterByCreatedAt=" + createdAt;
    // }
    // if (event.filters != undefined && event.filters["createdby"] != undefined) {
    //   params += "&filterByCreatedby=" + event.filters["createdby"].value;
    // }
    // if (event.filters != undefined && event.filters["updated_at"] != undefined) {
    //   const createdAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
    //   params += "&filterByUpdatedAt=" + createdAt;
    // }
    // if (event.filters != undefined && event.filters["updatedby"] != undefined) {
    //   params += "&filterByUpdatedBy=" + event.filters["updatedby"].value;
    // }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    // if (event.sortField != undefined && event.sortOrder != undefined) {
    //   let orderBy = "";
    //   if (event.sortOrder == 1) {
    //     orderBy = "DESC";
    //   } else {
    //     orderBy = "ASC";
    //   }
    //   query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    // }
    /**
    * Sequence wise sort.
    **/
    // else {
    //     query += "&sortBy=getSequencewise" + "&orderBy=desc";
    // }
    this.academyService.getAcademyList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        this.academiesList = data.data.items;
        console.log(this.academiesList);
        this.academiesList.forEach((element, index) => {
          if (element.tournamentData.length > 0) {
            element.tournamentData.forEach(tournamentDataElement => {
              console.log('tournamentDataElement', tournamentDataElement);


            });
          }
        })
        this.totalRecords = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadAcademiesTournament(this.lazyLoadEvent);
    let propertiesRemove = [
      "items",
      "citycode",
      "statecode",
      "countrycode",
      "description",
      "id",
      "created_at",
      "createdby",
      "updatedby",
      "disable",
      "updated_at",
      "categoryId",
      "status",
      "created_by",
      "Modification_Date",
      "endUserId",
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "academypic",
      "address",
      "countryname",
      "mobileNumber",
      "statename",
      "cityname",
      "zipcode",
      "totalcoaches",
      "preferredwaytocontact",
      "membershipType",
      "email",
      "firstName",
      "lastName",
      "websiteurl",
      "noofHard",
      "noofclay",
      "noofgrass",
      "pointStructure",
      "academyAvgReview",
      "foundedyear",
      "tournamentCategoriesCount",
      "foundedyea",
      "beginnerMorning"

    ];
    this.downloadAcademiesList = this.academiesList;
    this.downloadAcademiesList.forEach(function (item) {
      if (item.updated_at != "") {
        item["Modification_Date"] = moment(item.updated_at).format(
          "DD-MM-YYYY"
        );
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadAcademiesList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Academy Tournament Report");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
